import { faCircleBolt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Chip,
  Stack,
  Step,
  StepLabel,
  Stepper,
  Typography
} from '@mui/material';

import { CaseIdLink } from '@/pages/Case/CaseIdLink';

import useStyles from './CaseDetailsBox.styles';
import type { DetailsBoxProps } from './CaseDetailsBox.types';

const CaseDetailsBox = (props: DetailsBoxProps) => {
  const { classes } = useStyles();
  const { id, labels, upperText, lowerText } = props;

  return (
    <Box key={id} className={classes.detailsContent}>
      {(upperText || Boolean(labels?.length)) && (
        <Stack
          className={classes.upperTextBox}
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2
          }}
        >
          {upperText && (
            <Typography sx={{ fontStyle: 'italic', pr: 3 }}>
              <CaseIdLink>{upperText}</CaseIdLink>
            </Typography>
          )}
          <Stack direction="row" sx={{ gap: 1 }}>
            {labels?.map((label: string) => (
              <Chip
                size="small"
                key={`${id}-${label}`}
                variant="outlined"
                label={label}
              />
            ))}
          </Stack>
        </Stack>
      )}
      <Stepper className={classes.lowerTextStep} orientation="vertical">
        {lowerText.map((text) => (
          <Step expanded key={`${id}-${text}`}>
            <StepLabel
              slots={{
                stepIcon: () => (
                  <FontAwesomeIcon
                    icon={faCircleBolt}
                    size="xl"
                    color="var(--mui-palette-text-secondary)"
                    style={{ marginLeft: '0.25rem' }}
                  />
                )
              }}
            >
              <CaseIdLink>{text}</CaseIdLink>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CaseDetailsBox;
